import React from 'react';

const CircleSliderHandle = ({ size = 16 }) => {
  const innerDotSize = size / 2;

  return (
    <svg
      className="ws-ui-circle-slider__handle"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
    >
      <circle cx={size / 2} cy={size / 2} r={size / 2} />
      <circle cx={size / 2} cy={size / 2} r={innerDotSize / 2} />
    </svg>
  );
};

CircleSliderHandle.displayName = 'CircleSliderHandle';

export default CircleSliderHandle;
